import { ChevronLeft, ChevronRight, ExpandLess, ExpandMore } from '@mui/icons-material'
import { Box, Button, Card, CardContent, CardHeader, CardMedia, Chip, Divider, IconButton, Stack, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { sanitize } from 'dompurify';
import { format } from 'date-fns';
import { de } from 'date-fns/locale';


function Post(props) {

    const { title, src, author, content, post } = props;
    const [expandContent, setExpandContent] = useState(true);
    const [isPortrait, setIsPortrait] = useState(false)
    const [images, setImages] = useState([]);
    const [index, setIndex] = useState(0);
    const [openImageDialog, setOpenImageDialog] = useState(false);


    function validateIsPortraitImage(url) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = function () {
                resolve(img.height > img.width); // true = Hochformat
            };
            img.onerror = function (err) {
                reject(new Error(`Bild konnte nicht geladen werden: ${url}`));
            };
            img.src = url;
        });
    }

    const nextImage = () => {
        if (index < images.length - 1) {
            setIndex(index + 1);
        }
        else {
            setIndex(0);
        }
    }

    const previousImage = () => {
        if (index > 0) {
            setIndex(index - 1);
        }
        else {
            setIndex(images.length - 1);
        }
    }


    useEffect(() => {
        if (src) {
            validateIsPortraitImage(JSON.parse(src)[0])
                .then((isPortrait) => {
                    console.log("Bild ist Hochformat?", isPortrait);
                    setIsPortrait(isPortrait);
                })
                .catch((err) => {
                    console.error("Fehler beim Laden des Bildes:", err.message);
                });
        }
    }, [src]);

    useEffect(() => {
        if (src) {
            setImages(JSON.parse(src));
        }
        else if (post?.img_url) {
            setImages(JSON.parse(post.img_url));
        }
        else { }

    }, []);

    return (
        <Card elevation={4} sx={{ border: 0, borderRadius: 2, ml: 1, mr: 1 }}>
            <Box sx={{ position: "relative", overflow: "hidden" }}>
                {isPortrait || images.length > 1 ?
                    <>
                        <CardMedia component="img" src={images && images[index]} sx={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover", filter: "blur(20px) brightness(0.6)", zIndex: 0, }} onClick={() => setOpenImageDialog(true)} />
                        <CardMedia component="img" src={images && images[index]} sx={{ position: "relative", zIndex: 1, height: "50vh", maxWidth: "100%", objectFit: "contain", display: "block", margin: "0 auto", transition: "1s" }} onClick={() => setOpenImageDialog(true)} />
                    </>
                    :
                    <CardMedia component="img" src={images && images[index]} sx={{ position: "relative", zIndex: 1, minHeight: "250px", maxWidth: "100%", objectFit: "contain", display: "block", margin: "0 auto", transition: "1s" }} onClick={() => setOpenImageDialog(true)} />
                }
                {images.length > 1 &&
                    <>
                        <IconButton size="large" onClick={() => previousImage()} sx={{ position: "absolute", top: "50%", left: 10, zIndex: 3, backgroundColor: "rgba(0, 0, 0, .6)", "&:active": { backgroundColor: "rgba(0, 0, 0, .6)" }, "&:hover": { backgroundColor: "rgba(0, 0, 0, .6)" } }}><ChevronLeft sx={{ zIndex: 2000 }} color="white" /></IconButton>
                        <IconButton size="large" onClick={() => nextImage()} sx={{ position: "absolute", top: "50%", right: 10, zIndex: 3, backgroundColor: "rgba(0, 0, 0, .6)", "&:active": { backgroundColor: "rgba(0, 0, 0, .6)" }, "&:hover": { backgroundColor: "rgba(0, 0, 0, .6)" } }}><ChevronRight sx={{ zIndex: 3 }} color="white" /></IconButton>

                        <Box sx={{ position: "absolute", bottom: 10, left: "50%", transform: "translateX(-50%)", borderRadius: 4, width: "auto", p: 1, display: "flex", justifyContent: "center", gap: 1, zIndex: 3, backgroundColor: "rgba(120,120,120,0.5)", }} >
                            {images.length > 1 &&
                                images.map((_, i) => (
                                    <Box key={i} sx={{ width: 10, height: 10, borderRadius: "50%", backgroundColor: i === index ? "rgba(0, 0, 0, 0.8)" : "rgba(0, 0, 0, 0.3)", transition: "background-color 0.3s", }} />))}
                        </Box>
                    </>
                }
            </Box>

            <CardHeader title={title} subheader={"Datum: " + format(new Date(post.reg_date), "d. MMMM yyyy", { locale: de })} subheaderTypographyProps={{ variant: "body2" }}></CardHeader>
            <CardContent>
                {/* Display first two lines, when collapses display all */}
                {/* <Collapse in={!expandContent} transition="auto" unmountOnExit>
                    <Typography dangerouslySetInnerHTML={{ __html: sanitize(content) }}></Typography>
                </Collapse> */}
                <Typography dangerouslySetInnerHTML={{ __html: sanitize(content) }} sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitLineClamp: expandContent ? 3 : 1000,
                    WebkitBoxOrient: 'vertical',
                }}></Typography>
                <Stack>
                    <Button endIcon={expandContent ? <ExpandMore /> : <ExpandLess />} onClick={() => { setExpandContent(!expandContent) }} sx={{ textTransform: "none" }}>{expandContent ? "Beitrag lesen" : "Beitrag einklappen"}</Button>
                </Stack>
                <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                    <Chip variant="outlined" size="small" color="primary" label={"#" + post.category}></Chip>
                </Stack>
            </CardContent>
            <Divider></Divider>
        </Card>
    )
}



export default Post